export const columnsDataComplex = [
  {
    Header: "ACTIVE",
    accessor: "status",
  },
  {
    Header: "APP",
    accessor: "iconUrl",
  },
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "SUGGESTIONS",
    accessor: "suggestions",
  },
  {
    Header: "TYPE",
    accessor: "biddingType",
  },
  {
    Header: "GEOS",
    accessor: "countries",
  },
  {
    Header: "DAILY CAP",
    accessor: "dailyBudgetCap",
  },
  {
    Header: "BID",
    accessor: "bid",
  },
  {
    Header: "ECPI",
    accessor: "ecpi",
  },
  {
    Header: "INSTALLS",
    accessor: "installs",
  },
  {
    Header: "SPEND",
    accessor: "spend",
  },
  {
    Header: "CLICKS",
    accessor: "clicks",
  },
  {
    Header: "CR",
    accessor: "conversion_rate",
  },
  {
    Header: "ID",
    accessor: "id",
  },
];
